/**
 * Device utility functions
 * Manages device identification
 */

const DEVICE_ID_KEY = "device_id";

/**
 * Get or create a unique device ID
 * Stores the device ID in localStorage for persistence
 */
export const getDeviceId = (): string => {
  let deviceId = localStorage.getItem(DEVICE_ID_KEY);

  if (!deviceId) {
    // Generate a unique device ID
    deviceId = generateDeviceId();
    localStorage.setItem(DEVICE_ID_KEY, deviceId);
  }

  return deviceId;
};

/**
 * Generate a unique device ID
 * Combines browser fingerprint with timestamp for uniqueness
 */
const generateDeviceId = (): string => {
  const timestamp = Date.now().toString(36);
  const random = Math.random().toString(36).substring(2, 15);
  const userAgent = navigator.userAgent.substring(0, 10).replace(/\s/g, "");

  return `${timestamp}-${random}-${userAgent}`.substring(0, 50);
};

/**
 * Clear device ID (useful for logout or testing)
 */
export const clearDeviceId = (): void => {
  localStorage.removeItem(DEVICE_ID_KEY);
};
